import type { HTMLAttributes } from "react";
import { cx } from "./cx";
import {
  settingOriginDescription,
  settingOriginKind,
  settingOriginLabel,
  type SettingLevel,
  type SettingOriginValue,
} from "./settingOriginModel";
import "./SettingOrigin.css";

export interface SettingOriginProps extends HTMLAttributes<HTMLSpanElement> {
  /** `origin[key]` from `GET /mappings/{id}/effective` (or "mixed" in bulk editors). */
  origin: SettingOriginValue;
  /** Level being edited — decides the wording. Default "mapping". */
  level?: SettingLevel;
  /** @deprecated alias of `level`. */
  viewLevel?: SettingLevel;
}

/**
 * Inheritance badge: "inherited" (outline), "inherited · guild" (guild fill),
 * "overridden"/"set" (overridden fill), "default", "mixed". Text carries the meaning.
 */
export function SettingOrigin({
  origin,
  level: levelProp,
  viewLevel,
  className,
  ...rest
}: SettingOriginProps) {
  const level: SettingLevel = levelProp ?? viewLevel ?? "mapping";
  const kind = settingOriginKind(origin, level);
  return (
    <span
      className={cx("ui-setting-origin", `ui-setting-origin--${kind}`, className)}
      title={settingOriginDescription(origin, level)}
      data-origin={origin}
      {...rest}
    >
      <span className="ui-setting-origin__dot" aria-hidden="true" />
      {settingOriginLabel(origin, level)}
    </span>
  );
}
